import axios from "axios";

const api = axios.create({
  withCredentials: true,
  headers: { Authorization: "Bearer " + localStorage.getItem("accessToken") },
});

export default class InvitationsService {
  static async acceptInvitation(data): Promise<any> {
    return await api.get(`api/invitations/accept?uuid=${data}`);
  }
}
